// src/components/studio/steps/Step1Recipient.tsx
import { motion, AnimatePresence } from "framer-motion";

interface Step1RecipientProps {
  customization: any;
  setCustomization: (c: any) => void;
  validation: any;
}

export default function Step1Recipient({
  customization,
  setCustomization,
  validation,
}: Step1RecipientProps) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="flex flex-col h-full py-6"
    >
      <div className="text-center mb-12 space-y-2">
        <motion.p
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 0.4, y: 0 }}
          className="text-[10px] uppercase tracking-[0.5em] text-white"
        >
          Establishing Connection
        </motion.p>
        <div className="h-px w-8 bg-primary/40 mx-auto" />
      </div>

      <div className="flex-1 flex flex-col justify-center space-y-16 max-w-sm mx-auto w-full">
        <div className="relative group">
          <label className="block text-[9px] font-black uppercase tracking-[0.4em] text-primary/60 mb-4 ml-1">
            Who is this for?
          </label>
          <input
            type="text"
            value={customization.recipientName || ""}
            onChange={(e) =>
              setCustomization({
                ...customization,
                recipientName: e.target.value,
              })
            }
            placeholder="Recipient's Name"
            className="w-full outline-none bg-transparent border-none text-2xl md:text-3xl font-serif text-white placeholder:text-white/10 focus:ring-0 transition-all"
            style={{ fontFamily: "'Playfair Display', serif" }}
          />
          <div className="relative h-px w-full bg-white/10 mt-2 overflow-hidden">
            <motion.div
              initial={{ x: "-100%" }}
              whileFocus={{ x: "0%" }}
              className="absolute inset-0 bg-gradient-to-r from-transparent via-primary to-transparent"
              transition={{ duration: 0.8 }}
            />
          </div>
        </div>

        <div className="relative group">
          <label className="block text-[9px] font-black uppercase tracking-[0.4em] text-primary/60 mb-4 ml-1">
            Who is this from?
          </label>
          <input
            type="text"
            value={customization.senderName || ""}
            onChange={(e) =>
              setCustomization({
                ...customization,
                senderName: e.target.value,
              })
            }
            placeholder="Your Name"
            className="w-full outline-none bg-transparent border-none text-2xl md:text-3xl font-serif text-white placeholder:text-white/10 focus:ring-0 transition-all"
            style={{ fontFamily: "'Playfair Display', serif" }}
          />
          <div className="relative h-px w-full bg-white/10 mt-2 overflow-hidden">
            <motion.div
              initial={{ x: "-100%" }}
              whileFocus={{ x: "0%" }}
              className="absolute inset-0 bg-gradient-to-r from-transparent via-primary to-transparent"
              transition={{ duration: 0.8 }}
            />
          </div>
        </div>
      </div>

      <div className="mt-auto pt-8 flex flex-col items-center gap-4">
        <AnimatePresence>
          {!validation.isStep1Valid ? (
            <motion.span
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0 }}
              className="text-[9px] uppercase tracking-widest text-primary/80 italic"
            >
              Please complete the identities
            </motion.span>
          ) : (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 0.3 }}
              className="flex items-center gap-2"
            >
              <div className="h-1 w-1 rounded-full bg-primary" />
              <span className="text-[8px] uppercase tracking-[0.4em]">Identities Secured</span>
              <div className="h-1 w-1 rounded-full bg-primary" />
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </motion.div>
  );
}
